import React, { useEffect, useRef, useState, useCallback } from 'react';

import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Modal, Button, Alert } from 'rsuite';

// redux
import {
  getCampaignLandingOrganizationId,
  getTermsConditionsElementId,
  updateCampaignElementValue
} from '../../redux/modules/campaignLandingPage';
// styles
import styles from './SignatureElement.module.less';
import SignatureCanvas from '../SignatureCanvas';
import { useFileUploadData } from '../../hooks';

const SignatureElement = ({
  _updateCampaignElementValue,
  qid,
  organizationId,
  termsElementId,
  element
}) => {
  const { isLoading, isError, mutateAsync } = useFileUploadData();
  const sigCanvas = useRef({});
  const sigPad = useRef({});
  const [signatureResult, setSignatureResult] = useState('');
  const [savedSignatureImage, setSavedSignatureImage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const onHide = () => {
    setShowModal(false);
  };
  const onClick = () => {
    setShowModal(true);
  };

  useEffect(() => {
    _updateCampaignElementValue({ qid, selected: false });
  }, [qid]);

  useEffect(() => {
    if (isError) {
      Alert.error('Error uploading signature, please try again.', 7500);
    }
  }, [isError]);

  const onClear = () => {
    sigPad.current.clear();
    setSignatureResult('');
  };
  const onCancel = () => {
    setShowModal(false);
  };
  const onSave = async () => {
    const blob = await (await fetch(signatureResult)).blob();
    const formData = new FormData();
    formData.append('file', blob);
    formData.append('organizationId', organizationId);
    const res = await mutateAsync({ data: formData });

    if (!res?.data) {
      return;
    }
    const resData = res?.data || {};

    const attachment = {
      id: resData?.attachmentId,
      filename: resData?.filename,
      extension: resData?.extension,
      path: resData?.path,
      size: resData?.size,
      originalFilename: resData?.originalFileName,
      contentType: resData?.contentType
    };
    _updateCampaignElementValue({ qid, attachment, isUploading: false });
    _updateCampaignElementValue({ qid: termsElementId, selected: true });
    setSavedSignatureImage(signatureResult);
    setShowModal(false);
  };

  useEffect(() => {
    if (!showModal) {
      setSignatureResult('');
    }
  }, [showModal]);

  const isSignatureValid = !!signatureResult;

  const onEnd = () => {
    const dataURL = sigCanvas.current.toDataURL();
    setSignatureResult(dataURL);
  };
  const measuredRef = useCallback((node) => {
    const resizeCanvas = (signaturePad, canvas) => {
      canvas.width = canvas.parentElement.clientWidth;
      canvas.height = 200;
      signaturePad.clear();
    };

    if (node !== null) {
      sigCanvas.current = node.getCanvas();
      sigPad.current = node.getSignaturePad();
      resizeCanvas(node.getSignaturePad(), node.getCanvas());
    }
  }, []);

  return (
    <>
      <div className={styles.vpElementInputContainer}>
        <div className={styles.vpElementSignatureLabelContainer}>
          <div className={styles.vpElementSignatureLabel}>
            {element?.label}
            {element?.required && <span className={styles.vpRequiredLabel}>*</span>}
          </div>
        </div>
        <section className={styles.vpElementSignatureContainer} onClick={onClick}>
          {savedSignatureImage ? (
            <img className={styles.vpElementSignatureSavedImage} src={savedSignatureImage} />
          ) : (
            <div className={styles.vpElementSignatureTapContainer}>Tap to Sign</div>
          )}
        </section>
      </div>

      <Modal
        overflow={true}
        className={styles.vpElementSignatureModal}
        size="lg"
        show={showModal}
        onHide={onHide}
      >
        <Modal.Header>
          <Modal.Title>
            <div className={styles.vpElementSignatureModalTitle}>Signature</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.vpElementSignatureCanvasContainer}>
            <SignatureCanvas
              clearOnResize={false}
              ref={measuredRef}
              onEnd={onEnd}
              backgroundColor="#f5f6f7"
            />
          </div>
          <div className={styles.vpElementSignatureDisclaimer}>
            By signing this form with an electronic signature, I agree that such signature will be
            as valid as a handwritten signature to the extent allowed by local laws.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className={styles.vpElementSignatureButtonContainer}>
            <div>
              <Button
                appearance="default"
                disabled={!isSignatureValid || isLoading}
                size="lg"
                onClick={onClear}
              >
                Clear
              </Button>
              <Button disabled={isLoading} appearance="default" size="lg" onClick={onCancel}>
                Cancel
              </Button>
            </div>
            <Button
              loading={isLoading}
              appearance="primary"
              disabled={!isSignatureValid || isLoading}
              size="lg"
              onClick={onSave}
            >
              Accept and Sign
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

SignatureElement.propTypes = {
  _updateCampaignElementValue: PropTypes.func,
  qid: PropTypes.string,
  organizationId: PropTypes.string,
  termsElementId: PropTypes.string,
  element: PropTypes.object
};

const mapStateToProps = (state) => ({
  organizationId: getCampaignLandingOrganizationId(state),
  termsElementId: getTermsConditionsElementId(state)
});

const mapDispatchToProps = {
  _updateCampaignElementValue: updateCampaignElementValue
};

export default connect(mapStateToProps, mapDispatchToProps)(SignatureElement);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/SignatureElement.jsx